/**
 * Generates a UUID v4 string
 * @returns A UUID v4 string
 */
export function generateUUID(): string {
  // Check if crypto.randomUUID is available (modern browsers and Node.js 16.7.0+)
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback implementation for environments without crypto.randomUUID
  // This is a simplified version of UUID v4 generation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
